import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

export const TooltipLabel = ({ label }: { label: string }) => (
  <span>
    {label}{' '}
    <Tooltip
      title={
        <div>
          <div>
            You can use - <i>text</i> <b>to create</b> • <i>text</i>
          </div>
        </div>
      }
    >
      <InfoCircleOutlined />
    </Tooltip>
  </span>
);
